import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { Observable, distinctUntilChanged, map, mergeMap, shareReplay, startWith, tap } from 'rxjs';

import { TextDirection } from '../direction/direction.service';
import { EnvironmentService } from '../environment';
import { PlatformService } from '../platform/platform.service';
import { RouterHelperService } from '../router/router-helper.service';

@Injectable({
  providedIn: 'root'
})
export class PageConfigService {
  public readonly isCompressedPageLayout$ = this.getCompressedLayout$();

  constructor(
    private readonly envService: EnvironmentService,
    private readonly platform: PlatformService,
    private readonly routerHelper: RouterHelperService,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  init(): void {
    this.setDocumentDirection();
    this.setDocumentLanguage();
  }

  private setDocumentDirection(): void {
    this.document.documentElement.dir = this.envService.isRtl ? TextDirection.RTL : TextDirection.LTR;
  }

  private setDocumentLanguage(): void {
    this.document.documentElement.lang = this.envService.language;
  }

  private getCompressedLayout$(): Observable<boolean> {
    return this.routerHelper.activatedRoute$.pipe(
      mergeMap(route => route.data),
      map(data => data.isCompressedPageLayout || this.envService.compressedPageLayout),
      tap(compressed => (this.envService.compressedPageLayout = this.platform.isServer ? compressed : null)),
      startWith(this.envService.compressedPageLayout),
      map(Boolean),
      distinctUntilChanged(),
      shareReplay(1)
    );
  }
}
